/**
 * Whether the «عدم دسترسی انجام معاملات» notice on the market page has been closed.
 *
 * Session storage rather than localStorage, because the handoff asks for exactly that: the
 * notice can be closed, and it comes back in the next session. A tab is the app's session
 * here — closing the app and opening it again is a new one, so the customer is told once
 * more rather than never again.
 */
export const MARKET_ACCESS_NOTICE_STORAGE_KEY = 'kala-market-access-notice-dismissed';

export function readMarketAccessNoticeDismissed(): boolean {
	try {
		return sessionStorage.getItem(MARKET_ACCESS_NOTICE_STORAGE_KEY) === 'true';
	} catch {
		// Private mode can refuse the read; an unreadable dismissal is no dismissal.
		return false;
	}
}

export function writeMarketAccessNoticeDismissed(): void {
	try {
		sessionStorage.setItem(MARKET_ACCESS_NOTICE_STORAGE_KEY, 'true');
	} catch {
		// Ignore quota / private-mode write failures.
	}
}
